module.exports = __webpack_public_path__ + "img/1586193673.0ab742f4.jpg";